import { render, staticRenderFns } from "./confirm-phrase.vue?vue&type=template&id=d050de3a"
import script from "./confirm-phrase.vue?vue&type=script&lang=js"
export * from "./confirm-phrase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports